import { render, staticRenderFns } from "./ContentNewUserPoint.vue?vue&type=template&id=7a6bc87c&scoped=true&"
import script from "./ContentNewUserPoint.vue?vue&type=script&lang=js&"
export * from "./ContentNewUserPoint.vue?vue&type=script&lang=js&"
import style0 from "./ContentNewUserPoint.vue?vue&type=style&index=0&id=7a6bc87c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6bc87c",
  null
  
)

export default component.exports